var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopedEconomyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0666504,
    y: 0.800049,
    width: 20.4,
    height: 20.4,
    rx: 10.2,
    fill: "#D1E9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44727 15H7.58984L7.60156 13.6289H9.44727C9.9082 13.6289 10.2969 13.5254 10.6133 13.3184C10.9297 13.1074 11.168 12.8008 11.3281 12.3984C11.4922 11.9961 11.5742 11.5098 11.5742 10.9395V10.5234C11.5742 10.0859 11.5273 9.70117 11.4336 9.36914C11.3438 9.03711 11.209 8.75781 11.0293 8.53125C10.8496 8.30469 10.6289 8.13477 10.3672 8.02148C10.1055 7.9043 9.80469 7.8457 9.46484 7.8457H7.55469V6.46875H9.46484C10.0352 6.46875 10.5566 6.56641 11.0293 6.76172C11.5059 6.95312 11.918 7.22852 12.2656 7.58789C12.6133 7.94727 12.8809 8.37695 13.0684 8.87695C13.2598 9.37305 13.3555 9.92578 13.3555 10.5352V10.9395C13.3555 11.5449 13.2598 12.0977 13.0684 12.5977C12.8809 13.0977 12.6133 13.5273 12.2656 13.8867C11.9219 14.2422 11.5098 14.5176 11.0293 14.7129C10.5527 14.9043 10.0254 15 9.44727 15ZM8.58594 6.46875V15H6.82812V6.46875H8.58594Z",
    fill: "#152C73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopedEconomyIcon);
export default __webpack_public_path__ + "static/media/developed-economy-icon.e5814533ddfe79ab493f4429777ff47d.svg";
export { ForwardRef as ReactComponent };